'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const leagueManageSecurityRoutes = [
  {
    path: 'securities',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'league.manage.security.list',
        props: true,
        component: () => import('../views/ManageSecurityListView.vue'),
      },
      {
        path: 'add',
        name: 'league.manage.security.add',
        props: true,
        component: () => import('../views/ManageSecurityAddView.vue'),
      },
    ],
  },
];
